// React Component: TroopScheduleStepMessageForm.js

import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  LEGACY_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
  LegacyResolvers,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields, screenInfo } from "./TrOOPScheduleStepMessageFormConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import { useModal } from "../../common_nextgen/hooks/ModalContext";

const TroopScheduleStepMessageForm = ({ mode }) => {
  const { axios_helper_no_header } = useAxios();
  const { TROOP_SCHEDULE_STEP, TROOP_SCHEDULE_STEP_MESSAGE } = ROUTE_PATHS;
  const location = useLocation();
  const navigateToPage = useCustomNavigate();

  const { state: stateVal = [] } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  let {
    selectedSteps = [],
    previousScreen = TROOP_SCHEDULE_STEP_MESSAGE,
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      tscScheduleName: selectedSteps[initialIndex].tscScheduleName,
      tsdStepNumber: selectedSteps[initialIndex].tsdStepNumber,
      tsmSeqNbr: selectedSteps[initialIndex].tsmSeqNbr,
    },
    schedule,
    stepNumber,
  } = currentState;

  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  const handleBack = () => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        acc[item["legacy"]] = formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/tsmTroopStepMessage";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/tsmTroopStepMessage";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        infoChanged= false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                    toast.current.show({
                                      severity: "info",
                                      summary: "",
                                      detail: responseStatus.message,
                                      life: 3000,
                                    });
                                  } else {
                                    toast.current.show({
                                      severity: "success",
                                      summary: "",
                                      detail: responseStatus.message,
                                      life: 3000,
                                    });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        currentState = {
          ...currentState,
          selectedSteps: [{ ...responseData }],
          currentIndex: 0,
        };
        navigateToPage(ROUTE_PATHS.TROOP_SCHEDULE_STEP_MESSAGE_EDIT, [
          ...previousState,
          currentState,
        ]);
      } else {
        setInitialFormData(responseData);
      }
    } }catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";

      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const params = isAddMode(currentMode)
        ? { tscScheduleName: schedule, tsdStepNumber: stepNumber }
        : {
            tsdStepNumber: selectedSteps[currentIndex].tsdStepNumber,
            tsmSeqNbr: selectedSteps[currentIndex].tsmSeqNbr,
          };
      let url = isAddMode(currentMode)
        ? `api/tsmTroopStepMessage/initialFormData/${encodeURIComponent(
            screenInfo.ADD[1]
          )}`
        : `api/tsmTroopStepMessage/${encodeURIComponent(
            selectedSteps[currentIndex].tscScheduleName
          )}`;
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        {},
        params
      );
      setInitialFormData(responseData);
    };

    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default TroopScheduleStepMessageForm;
